
import { computed, defineComponent, PropType } from 'vue'

import { PlanningRecordInvoice } from '@/new-services/types/planning'

// @components
import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    props: {
        column: {
            type: Object as PropType<{ name: string; key: string }>,
            required: true,
        },
        row: {
            type: Object as PropType<PlanningRecordInvoice>,
            required: true,
        },
    },
    components: {
        Cheap,
    },
    setup(props) {
        const getCheckOrTimesIcon = (is_check: number | boolean) => {
            return `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`
        }

        const getShipmentIcon = (type_id: number) => {
            let class_str = 'fas '

            if (type_id === 1) {
                class_str += 'fa-car'
            } else {
                class_str += 'fa-plane'
            }

            return class_str
        }

        const getTimerClass = computed(() => {
            if (!props.row.timer) return

            if (props.row.timer[0] === '-') {
                return 'text-red-500'
            } else {
                return 'text-green-500'
            }
        })

        return { getCheckOrTimesIcon, getShipmentIcon, getTimerClass }
    },
})
